export type MovementPosition = { x: number; depth: number; height: number; mapId?: string | undefined };
export type MovementAuthority = MovementPosition & { lastMoveSeq?: number | undefined };

/**
 * The server echoes the input sequence it has actually processed.
 * Never rewind local prediction to an older server snapshot.
 */
export class MovementSync {
  private nextSeq = 0;
  private latest: { seq: number; position: MovementPosition } | null = null;
  private reconciledSeq = 0;

  reset(): void {
    this.nextSeq = 0;
    this.latest = null;
    this.reconciledSeq = 0;
  }

  record(position: MovementPosition): number {
    this.nextSeq += 1;
    this.latest = { seq: this.nextSeq, position: { ...position } };
    return this.nextSeq;
  }

  consumeCorrection(authority: MovementAuthority): { x: number; depth: number; height: number } | null {
    const sent = this.latest;
    const ack = authority.lastMoveSeq;
    if (!sent || ack !== sent.seq || ack <= this.reconciledSeq) return null;
    this.reconciledSeq = ack;
    if ((authority.mapId ?? 'village') !== (sent.position.mapId ?? 'village')) return null;
    const delta = {
      x: authority.x - sent.position.x,
      depth: authority.depth - sent.position.depth,
      height: authority.height - sent.position.height,
    };
    if (Math.max(Math.abs(delta.x), Math.abs(delta.depth), Math.abs(delta.height)) < 8) return null;
    return delta;
  }
}
